import { type RawAppType } from './types/raw-app.type.ts';

export const rawApp: RawAppType = {
    isMainTab: false,
    tabs: [],
    openedApps: [],
};
